export default __webpack_public_path__ + "static/media/404.1c4caaa7.png";